"use client";

import { useState, useEffect } from "react";
import { toast } from "react-toastify";
import api from "../../services/api";

const EnrollmentForm = ({ onEnrollmentSuccess }) => {
  const [courses, setCourses] = useState([]);
  const [students, setStudents] = useState([]);
  const [selectedCourse, setSelectedCourse] = useState("");
  const [selectedStudent, setSelectedStudent] = useState("");
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [coursesRes, studentsRes] = await Promise.all([
          api.get("/courses"),
          // Fetch only users with role=student
          api.get("/users?role=student"),
        ]);

        setCourses(coursesRes.data.data);
        // In case the backend doesn't filter correctly, add an extra filter:
        const filteredStudents = (studentsRes.data.data || []).filter(
          (user) => {
            if (typeof user.role === "object" && user.role !== null) {
              return user.role.name === "student";
            }
            return user.role === "student";
          }
        );
        setStudents(filteredStudents);
      } catch (error) {
        toast.error("Failed to load data");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      await api.post("/enrollments", {
        courseId: selectedCourse,
        studentId: selectedStudent,
      });

      toast.success("Student enrolled successfully");
      setSelectedCourse("");
      setSelectedStudent("");
      onEnrollmentSuccess?.();
    } catch (error) {
      toast.error(error.response?.data?.message || "Enrollment failed");
    }
  };

  if (loading) return <div>Loading...</div>;

  return (
    <div className="p-4 bg-white rounded-lg shadow enrollment-form">
      <h2 className="mb-4 text-xl font-semibold">Manual Enrollment</h2>
      <form onSubmit={handleSubmit} className="space-y-4">
        <div>
          <label className="block mb-1 text-sm font-medium">Course</label>
          <select
            value={selectedCourse}
            onChange={(e) => setSelectedCourse(e.target.value)}
            className="w-full p-2 border rounded"
            required
          >
            <option value="">Select Course</option>
            {courses.map((course) => (
              <option key={course._id} value={course._id}>
                {course.name} ({course.code})
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block mb-1 text-sm font-medium">Student</label>
          <select
            value={selectedStudent}
            onChange={(e) => setSelectedStudent(e.target.value)}
            className="w-full p-2 border rounded"
            required
          >
            <option value="">Select Student</option>
            {students.map((student) => (
              <option key={student._id} value={student._id}>
                {student.firstName} {student.lastName}
              </option>
            ))}
          </select>
        </div>

        <button
          type="submit"
          className="px-4 py-2 text-white bg-blue-600 rounded hover:bg-blue-700"
        >
          Enroll Student
        </button>
      </form>
    </div>
  );
};

export default EnrollmentForm;
